import { InjectionKey } from 'vue'
import { UploadService } from './impl/UploadService.impl'
import SyncStoreAndRouteService from './impl/SyncStoreAndRouteService.impl'
import ProviderIconService from './impl/ProviderIconService.impl'
import { ISnapshotService } from './ISnapshotService'
import { ISearchService } from './ISearchService'
import { IProjectService } from './IProjectService'
import { IGlobalFilterService } from './IGlobalFilterService'
import { ICustomMetricService } from './ICustomMetricService'
import { IArtifactService } from './IArtifactService'
import { IDashboardService } from './IDashboardService'
import ColorConverterService from './impl/ColorConverterService.impl'
import ChartService from './IChartService'
import RappidContext from '@/pages/explorer/rappid/rappid-context'
import GlobalFilterToolboxService from './impl/GlobalFiltersToolboxService'

export const ServiceKeys = {
  upload: Symbol('upload') as InjectionKey<UploadService>,
  snapshot: Symbol('snapshot') as InjectionKey<ISnapshotService>,
  search: Symbol('search') as InjectionKey<ISearchService>,
  project: Symbol('project') as InjectionKey<IProjectService>,
  artifact: Symbol('artifact') as InjectionKey<IArtifactService>,
  sync: Symbol('sync') as InjectionKey<SyncStoreAndRouteService>,
  providerIcon: Symbol('providerIcon') as InjectionKey<ProviderIconService>,
  globalFilter: Symbol('globalFilter') as InjectionKey<IGlobalFilterService>,
  customMetrics: Symbol('customMetrics') as InjectionKey<ICustomMetricService>,
  dashboard: Symbol('dashboard') as InjectionKey<IDashboardService>,
  colorConverter: Symbol('colorConverter') as InjectionKey<ColorConverterService>,
  chart: Symbol('chart') as InjectionKey<ChartService>,
  rappidContext: Symbol('rappidContext') as InjectionKey<RappidContext>,
  globalFiltersToolbox: Symbol('globalFiltersToolbox') as InjectionKey<GlobalFilterToolboxService>,
}
